<div class="realtime-viewports" id="overlay-canvas-viewports"></div>
<div class="realtime-pointers" id="overlay-canvas-svg-pointer"></div>
<canvas appChromeCanvasBugWorkaround id="overlay-canvas" class="overlay-canvas"></canvas>
